export default __webpack_public_path__ + "assets/images/dfa690e2d1c29a6acf9005a91b72cdd8.svg";